import axios from 'axios';
import { getInSession } from './../persistence/session';

/**
 * Creates a new axios instance and sets configuration.
 * @type {AxiosInstance}
 */
export const dfimAxios = axios.create({
  credentials: 'same-origin',
});

/**
 * Add a request interceptor to apply credentials
 * */
dfimAxios.interceptors.request.use(
  (request) => {
    const accessToken = getInSession('dfim-jwt-access-token');
    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);
